import { render, staticRenderFns } from "./EventbriteTicketClassesInput.vue?vue&type=template&id=4760c7a2"
import script from "./EventbriteTicketClassesInput.vue?vue&type=script&lang=js"
export * from "./EventbriteTicketClassesInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports